import { Befehl } from '../models'
import { findAuftrag, hasField, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 8 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 7.20: requires signal AND zugmeldestelle.name in field 7.21
 * - Other aufträge (7.10, 7.25) have no content fields
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl8EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty using generic check
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules for 7.20
  const auftrag850 = findAuftrag(befehl, '8.50')
  if (auftrag850) {
    if (auftrag850.felder && auftrag850.felder.length > 0) {
      const hasArt1 = hasFieldContent(auftrag850, '8.43', 'zugmeldestelle.art')
      const hasName1 = hasFieldContent(
        auftrag850,
        '8.43',
        'zugmeldestelle.name'
      )
      if (!hasArt1 || !hasName1) {
        return true
      }

      const has844 = hasField(auftrag850, '8.44')
      const hasArt2 = hasFieldContent(auftrag850, '8.44', 'zugmeldestelle.art')
      const hasName2 = hasFieldContent(
        auftrag850,
        '8.44',
        'zugmeldestelle.name'
      )
      if (has844 && (!hasArt2 || !hasName2)) {
        return true
      }
    }
  }

  // All checks passed - no empty fields
  return false
}
